// extracted by mini-css-extract-plugin
export default {"titleContainer":"headerTitle_titleContainer__d5H+S","titleBlock":"headerTitle_titleBlock__geYLl","icon":"headerTitle_icon__PE7io","actions":"headerTitle_actions__UC8ek"};